module.exports = __webpack_public_path__ + "img/zz1.5660c2be.png";